// extracted by mini-css-extract-plugin
module.exports = {"mobile":"screen and (max-width: 600px)","wrapper":"wrapper-2OJ9a","wrapper_arrowed":"wrapper_arrowed-1iNCK","header":"header-34rFP","icon":"icon-36Ybb","body":"body-1GC6L"};